import React, { createContext, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import SaleItemGroup from './sale-item-group';
import SaleHeader from './sale-header';
import SaleAccordion from './sale-accordion';
import { SaleItemsContext } from '../index';
import * as c from '../../ts/const';
import classNames from 'classnames';
import ParticlesBox from '../components/particles-box';
/**
 * 表示切り替えに使用するreducerの設定
 */
const saleItemListDisplayReducer = (state, action) => {
    switch (action) {
        case 'show':
            return { show: true };
        case 'hide':
            return { show: false };
        case 'toggle':
            return { show: !state.show };
        default:
            return state;
    }
};
// セールプロパティをナビゲーションまで受け渡す用
export const SalePropContext = createContext(undefined);
const ASale = ({ saleProp }) => {
    // セール
    const [saleItemsState] = useContext(SaleItemsContext);
    // このブロックに必要なセールリスト
    const [saleItemList, setSaleItemList] = useState([]);
    // セール期間
    const salePeriod = useMemo(() => saleProp.sale_period, [saleProp]);
    // セールステータス
    const saleStatus = useMemo(() => saleProp.sale_status, [saleProp]);
    // クラス名にセール期間を追加、CSSでの色変更用
    const className = useMemo(() => classNames('a-sale', `sale-period-${salePeriod}`), [salePeriod]);
    // 一覧の表示切り替えレデューサ
    const [saleItemListDisplayState, saleItemListDisplayDispatch] = useReducer(saleItemListDisplayReducer, { show: true });
    // セールアイテムの参照
    useEffect(() => {
        // セールステータスが終了の場合
        if (saleStatus === 2) {
            // 一覧の非表示化を親に通知
            saleItemListDisplayDispatch('hide');
        }
        // セールデータに対応する期間の情報が存在する場合
        if (saleItemsState && saleItemsState.saleItems[salePeriod]) {
            // 対応する期間のセールデータをセットする
            setSaleItemList(saleItemsState?.saleItems[salePeriod]);
        }
    }, [
        saleStatus,
        saleProp,
        saleItemsState
    ]);
    return (React.createElement(SalePropContext.Provider, { value: saleProp },
        React.createElement("div", { className: className, id: saleProp.id || '' },
            React.createElement(SaleHeader, { saleProp: saleProp, saleItemListDisplay: saleItemListDisplayDispatch }),
            saleStatus !== 0 && (React.createElement("div", { className: 'a-sale-body' },
                React.createElement(ParticlesBox, { id: `sale-pb-${salePeriod}`, settingsFile: `./assets/json/particles-settings-base.json?${c.CACHEBUSTER}`, largeSettingsFile: `${saleProp.large_particles_file}?${c.CACHEBUSTER}`, smallSettingsFile: `${saleProp.small_particles_file}?${c.CACHEBUSTER}` },
                    React.createElement(SaleAccordion, { show: saleItemListDisplayState.show },
                        React.createElement(SaleItemGroup, { saleItemList: saleItemList }))))))));
};
export default ASale;
